import MQuantitySelector from './MQuantitySelector.vue';

MQuantitySelector.install = (app) => {
  app.component('MQuantitySelector', MQuantitySelector);
};

export { MQuantitySelector };
